module.exports = __webpack_public_path__ + "fonts/VetoSans-Italic.a5626598.woff2";